import { Link } from "react-router-dom";
import React, {useState} from 'react';
import { Box, Typography, Button, Divider, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Checkbox } from '@mui/material';
import Navbar from '../Layouts/Navbar';
import MenuIcon from '@mui/icons-material/Menu';
import DirectionsBusIcon from "@mui/icons-material/DirectionsBus";
import FileCopyIcon from '@mui/icons-material/FileCopy';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';

export default function DetailsNavette() {
      const [selected, setSelected] = useState([]);
      const handleSelectAll = (event) => {
        if (event.target.checked) {
          const newSelected = data.passagersNonAffectes.map(n => n.matricule);
          setSelected(newSelected);
        } else {
          setSelected([]);
        }
      };
      const handleSelectOne = (event, matricule) => {
        const selectedIndex = selected.indexOf(matricule);
        let newSelected = [];
        
        if (selectedIndex === -1) {
          newSelected = newSelected.concat(selected, matricule);
        } else if (selectedIndex === 0) {
          newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
          newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
          newSelected = newSelected.concat(
            selected.slice(0, selectedIndex),
            selected.slice(selectedIndex + 1),
          );
        }
        
        setSelected(newSelected);
      };
    
      const isSelected = (matricule) => selected.indexOf(matricule) !== -1;
    
      const handleAddSelected = () => {
        console.log("Adding selected passengers:", selected);
      };

    const data = {
      date: '26/03/2025',
      heure: '9',
      start_at: '',
      end_at: '',
      societe: '',
      direction: 'Entrée',
      trajet: 'ZONE 03: AZLI - IZIKI - AIN MZOUAR',
      statut: 'en attente',
      vehicule: '',
      chauffeur: '',
      pickup: '',
      dropoff: 'Toubkal',
      distance: '',
      duree: '',
      commentaire: '',
      passagers: [
        { 
          matricule: '20421', 
          nom: 'TEST Hicham Elkarimi', 
          pickup: '06.RUE EL IKHAA - PHARMACIE DE LA BASE', 
          dropoff: 'Toubkal',
          heure: ''
        },
        { 
          matricule: '20429', 
          nom: 'TEST Miriam EL QARFADI', 
          pickup: '01.AV LA AAYOUNE - PHARMACIE LAAYOUNE', 
          dropoff: 'Toubkal',
          heure: ''
        },
        { 
          matricule: '20632', 
          nom: 'Soukaina EL HOUZI TEST', 
          pickup: '02.AV LAAYOUNE - FRAN TRAB', 
          dropoff: 'Toubkal',
          heure: ''
        }
      ],
      passagersNonAffectes: [
        {
          matricule: '20423',
          nom: 'TEST Lamia ILKAGHENE',
          pickup: '02 MASSIRA 3 - MOSQUÉE ASSOUNNA',
          dropoff: 'Toubkal',
          distance: 'km',
          navette: '797',
          trajet: 'ZONE 05: MASSIRA 2-3'
        },
        {
          matricule: '20380',
          nom: 'TEST Nouhaila EL HARCHANI',
          pickup: '05 MASSIRA 1 - PATISSERIE AL FADL',
          dropoff: 'Toubkal',
          distance: 'km',
          navette: '797',
          trajet: 'ZONE 05: MASSIRA 2-3'
        },
        {
          matricule: '20544',
          nom: 'TEST ASSIA BOUTALEB',
          pickup: '01 MASSIRA 3 - ATTIJARIWAFA BANK',
          dropoff: 'Toubkal',
          distance: 'km',
          navette: '797',
          trajet: 'ZONE 05: MASSIRA 2-3'
        },
        {
          matricule: '20378',
          nom: 'TEST Adil JABRI',
          pickup: '02 MASSIRA 3 - MOSQUÉE ASSOUNNA',
          dropoff: 'Toubkal',
          distance: 'km',
          navette: '797',
          trajet: 'ZONE 05: MASSIRA 2-3'
        },
        {
          matricule: '20343',
          nom: 'TEST Fatima Zahra ZIDANE',
          pickup: '02 MASSIRA 3 - MOSQUÉE ASSOUNNA',
          dropoff: 'Toubkal',
          distance: 'km',
          navette: '797',
          trajet: 'ZONE 05: MASSIRA 2-3'
        },
        {
          matricule: '20329',
          nom: 'TEST Younes Khalil LAARIBI',
          pickup: '04.DAR SALAM - MOSQUÉE DAR SALAM',
          dropoff: 'Toubkal',
          distance: 'km',
          navette: '799',
          trajet: 'ZONE 06: AFAQ - DOHA'
        },
        {
          matricule: '20325',
          nom: 'TEST Salwa EL BOUJEDAINI',
          pickup: '05.RTE DE SOUIHLA - MOSQUÉE DOHA',
          dropoff: 'Toubkal',
          distance: 'km',
          navette: '799',
          trajet: 'ZONE 06: AFAQ - DOHA'
        },
        {
          matricule: '20313',
          nom: 'TEST Karim BOUZBOUNE',
          pickup: '07.DOHA - CAFÉ ELENA',
          dropoff: 'Toubkal',
          distance: 'km',
          navette: '799',
          trajet: 'ZONE 06: AFAQ - DOHA'
        }
      ]
    };
    
  
  return (
    <>
      <Navbar />
      <Box p={3}>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Box display="flex" alignItems="center">
            <DirectionsBusIcon />
            <Typography variant="h6" ml={1}>NAVETTE</Typography>
          </Box>
          <Box display="flex" gap={2}>
            <Button
              component={Link}
              to="/navette"
              variant="outlined"
              sx={{
                color: 'red',
                borderColor: 'red',
                textTransform: 'none',
                '&:hover': { backgroundColor: 'red', color: '#fff', borderColor: 'red' },
              }}
              startIcon={<MenuIcon />}
            >
              Liste
            </Button>
            <Button
              variant="outlined"
              sx={{
                color: 'red',
                borderColor: 'red',
                textTransform: 'none',
                '&:hover': { backgroundColor: 'red', color: '#fff', borderColor: 'red' },
              }}
              startIcon={<FileCopyIcon />}
            >
              Dupliquer
            </Button>
            <Button
              variant="outlined"
              sx={{
                color: 'red',
                borderColor: 'red',
                textTransform: 'none',
                '&:hover': { backgroundColor: 'red', color: '#fff', borderColor: 'red' },
              }}
              startIcon={<RestartAltIcon />}
            >
              Reset
            </Button>
          </Box>
        </Box>

        {/* Information Section */}
        <Box sx={{ backgroundColor: '#000', p: 1, mb: 2 }}>
          <Typography variant="subtitle1" color="white">
            INFORMATIONS SUR LA NAVETTE
          </Typography>
        </Box>

        {/* Main Data Section - Updated with spans */}
        <Box flex={1} pr={2}>
          <Box display="flex" py={1}>
            <Box width="25%">
              <Typography sx={{fontWeight:'bold'}}>Date</Typography>
            </Box>
            <Box width="25%">
              <Typography>{data.date}</Typography>
            </Box>
            <Box width="25%">
              <Typography sx={{fontWeight:'bold'}}>Heure</Typography>
            </Box>
            <Box width="25%">
              <Typography>{data.heure}</Typography>
            </Box>
          </Box>
          <Divider />

          <Box display="flex" py={1}>
            <Box width="25%">
              <Typography sx={{fontWeight:'bold'}}>Start at</Typography>
            </Box>
            <Box width="25%">
              <Typography>{data.start_at}</Typography>
            </Box>
            <Box width="25%">
              <Typography sx={{fontWeight:'bold'}}>End at</Typography>
            </Box>
            <Box width="25%">
              <Typography>{data.end_at}</Typography>
            </Box>
          </Box>
          <Divider />

          <Box display="flex" py={1}>
            <Box width="25%">
              <Typography sx={{fontWeight:'bold'}}>Société</Typography>
            </Box>
            <Box width="25%">
              <Typography>{data.societe}</Typography>
            </Box>
            <Box width="25%">
              <Typography sx={{fontWeight:'bold'}}>Direction</Typography>
            </Box>
            <Box width="25%">
              <Typography>{data.direction}</Typography>
            </Box>
          </Box>
          <Divider />

          <Box display="flex" py={1}>
            <Box width="25%">
              <Typography sx={{fontWeight:'bold'}}>Trajet</Typography>
            </Box>
            <Box width="25%">
              <Typography>{data.trajet}</Typography>
            </Box>
            <Box width="25%">
              <Typography sx={{fontWeight:'bold'}}>Statut</Typography>
            </Box>
            <Box width="25%">
              <Typography>{data.statut}</Typography>
            </Box>
          </Box>
          <Divider />

          <Box display="flex" py={1}>
            <Box width="25%">
              <Typography sx={{fontWeight:'bold'}}>Véhicule</Typography>
            </Box>
            <Box width="25%">
              <Typography>{data.vehicule}</Typography>
            </Box>
            <Box width="25%">
              <Typography sx={{fontWeight:'bold'}}>Chauffeur</Typography>
            </Box>
            <Box width="25%">
              <Typography>{data.chauffeur}</Typography>
            </Box>
          </Box>
          <Divider />

          <Box display="flex" py={1}>
            <Box width="25%">
              <Typography sx={{fontWeight:'bold'}}>Pick-up</Typography>
            </Box>
            <Box width="25%">
              <Typography>{data.pickup}</Typography>
            </Box>
            <Box width="25%">
              <Typography sx={{fontWeight:'bold'}}>Drop-off</Typography>
            </Box>
            <Box width="25%">
              <Typography>{data.dropoff}</Typography>
            </Box>
          </Box>
          <Divider />

          <Box display="flex" py={1}>
            <Box width="25%">
              <Typography sx={{fontWeight:'bold'}}>Distance</Typography>
            </Box>
            <Box width="25%">
              <Typography>{data.distance}</Typography>
            </Box>
            <Box width="25%">
              <Typography sx={{fontWeight:'bold'}}>Durée</Typography>
            </Box>
            <Box width="25%">
              <Typography>{data.duree}</Typography>
            </Box>
          </Box>
          <Divider />

          <Box display="flex" py={1}>
            <Box width="25%">
              <Typography sx={{fontWeight:'bold'}}>Commentaire</Typography>
            </Box>
            <Box width="75%">
              <Typography>{data.commentaire}</Typography>
            </Box>
          </Box>
          <Divider />
        </Box>

        {/* Passengers Section */}
        <Box sx={{ backgroundColor: '#000', p: 1, mb: 2, mt: 4 }}>
          <Typography variant="subtitle1" color="white">
            PASSAGERS AFFECTÉS À CETTE NAVETTE
          </Typography>
        </Box>

        {/* Passengers Table using TableContainer */}
        <TableContainer component={Paper} sx={{ boxShadow: 'none', border: '1px solid rgba(224, 224, 224, 1)' }}>
          <Table sx={{ minWidth: 650 }}>
            <TableHead>
              <TableRow>
                <TableCell sx={{fontWeight:'bold'}}>Matricule</TableCell>
                <TableCell sx={{fontWeight:'bold'}}>Nom</TableCell>
                <TableCell sx={{fontWeight:'bold'}}>Pick-up</TableCell>
                <TableCell sx={{fontWeight:'bold'}}>Drop-off</TableCell>
                <TableCell sx={{fontWeight:'bold'}}>Heure de passage</TableCell>
                <TableCell sx={{fontWeight:'bold'}}>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.passagers.map((passager, index) => (
                <TableRow key={index}>
                  <TableCell>{passager.matricule}</TableCell>
                  <TableCell>{passager.nom}</TableCell>
                  <TableCell>{passager.pickup}</TableCell>
                  <TableCell>{passager.dropoff}</TableCell>
                  <TableCell>{passager.heure}</TableCell>
                  <TableCell>
                    <Box sx={{ display: 'flex', gap: 1 }}>
                      <Button
                        variant="outlined"
                        size="small"
                        startIcon={<EditIcon />}
                        sx={{
                            color: 'red',
                            borderColor: 'red',
                            textTransform: 'none',
                            '&:hover': { backgroundColor: 'red', color: '#fff', borderColor: 'red' },
                        }}
                      >
                        Modifier
                      </Button>
                      <Button
                        variant="outlined"
                        size="small"
                        startIcon={<DeleteIcon />}
                        sx={{
                            color: 'red',
                            borderColor: 'red',
                            textTransform: 'none',
                            '&:hover': { backgroundColor: 'red', color: '#fff', borderColor: 'red' },
                        }}
                      >
                        Supprimer
                      </Button>
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Box sx={{ backgroundColor: '#000', p: 1, mb: 2 }}>
          <Typography variant="subtitle1" color="white">
            PASSAGERS NON AFFECTÉS À CETTE NAVETTE
          </Typography>
        </Box>

        {/* Non-Affected Passengers Table */}
        <TableContainer component={Paper} sx={{ boxShadow: 'none', border: '1px solid rgba(224, 224, 224, 1)' }}>
          <Table sx={{ minWidth: 650 }}>
            <TableHead>
              <TableRow>
                <TableCell padding="checkbox">
                   <Checkbox
                    indeterminate={selected.length > 0 && selected.length < data.passagersNonAffectes.length}
                    checked={data.passagersNonAffectes.length > 0 && selected.length === data.passagersNonAffectes.length}
                    onChange={handleSelectAll}
                    sx={{
                        '&.MuiCheckbox-indeterminate': {
                        color: '#000',
                        },
                        '&.Mui-checked': {
                        color: '#000',
                        },
                    }}
                />
                </TableCell>
                <TableCell sx={{fontWeight:'bold'}}>Matricule</TableCell>
                <TableCell sx={{fontWeight:'bold'}}>Nom</TableCell>
                <TableCell sx={{fontWeight:'bold'}}>Pick-up</TableCell>
                <TableCell sx={{fontWeight:'bold'}}>Drop-off</TableCell>
                <TableCell sx={{fontWeight:'bold'}}>distance</TableCell>
                <TableCell sx={{fontWeight:'bold'}}>Navette</TableCell>
                <TableCell sx={{fontWeight:'bold'}}>Trajet</TableCell>
                <TableCell sx={{fontWeight:'bold'}}>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.passagersNonAffectes.map((passager) => {
                const isItemSelected = isSelected(passager.matricule);
                
                return (
                  <TableRow 
                    key={passager.matricule}
                    selected={isItemSelected}
                    sx={{ '&.Mui-selected': { backgroundColor: 'rgba(0, 0, 0, 0.04)' } }}
                  >
                    <TableCell padding="checkbox">
                   <Checkbox
                        checked={isItemSelected}
                        onChange={(event) => handleSelectOne(event, passager.matricule)}
                        sx={{
                            '&.MuiCheckbox-indeterminate': {
                            color: '#000',
                            },
                            '&.Mui-checked': {
                            color: '#000',
                            },
                        }}
                        />
                    </TableCell>
                    <TableCell>{passager.matricule}</TableCell>
                    <TableCell>{passager.nom}</TableCell>
                    <TableCell>{passager.pickup}</TableCell>
                    <TableCell>{passager.dropoff}</TableCell>
                    <TableCell>{passager.distance}</TableCell>
                    <TableCell>{passager.navette}</TableCell>
                    <TableCell>{passager.trajet}</TableCell>
                    <TableCell>
                      <Button
                        variant="outlined"
                        size="small"
                        startIcon={<AddIcon />}
                        sx={{
                            color: 'red',
                            borderColor: 'red',
                            textTransform: 'none',
                            '&:hover': { backgroundColor: 'red', color: '#fff', borderColor: 'red' },
                          }}
                      >
                        Ajouter
                      </Button>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
        
        {/* Added footer with selection count and add selection button */}
        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          mt: 2,
          mb: 3,
          px: 2
        }}>
          <Typography variant="body2">
            {selected.length} élément{selected.length !== 1 ? 's' : ''} sélectionné{selected.length !== 1 ? 's' : ''}
          </Typography>
          <Button
            variant="Outlined"
            disabled={selected.length === 0}
            startIcon={<AddIcon />}
            onClick={handleAddSelected}
            sx={{
                color: 'red',
                borderColor: 'red',
                textTransform: 'none',
                '&:hover': { backgroundColor: 'red', color: '#fff', borderColor: 'red' },
              '&.Mui-disabled': { backgroundColor: 'rgba(37, 37, 37, 0.3)', color: 'rgba(255, 255, 255, 0.7)' }
            }}
          >
            Ajouter sélection
          </Button>
          </Box>
           {/* Map section */}
          <Box sx={{ backgroundColor: '#000', p: 1, mb: 2, mt: 4 }}>
            <Typography variant="subtitle1" color="white">
               Calculateur d'itinéraire de véhicule avec trafic et arrêts
            </Typography>
        </Box>
        <Box sx={{display: 'flex', gap: 1}}>
            <Button
                variant="contained"
                sx={{
                backgroundColor: '#000',
                color: '#fff',
                textTransform: 'none',
                width: '40%',
                '&:hover': {
                    backgroundColor: 'red',
                },
                }}
            >
                 Calculateur d'itinéraire et synchroniser les informatios
            </Button>
            <Button
                variant="contained"
                sx={{
                backgroundColor: '#000',
                color: '#fff',
                textTransform: 'none',
                width: '40%',
                '&:hover': {
                    backgroundColor: 'red',
                },
                }}
            >
                Mettre a jour les donnes de trafic
            </Button>
            <Button
                variant="contained"
                sx={{
                backgroundColor: '#000',
                color: '#fff',
                textTransform: 'none',
                width: '40%',
                '&:hover': {
                    backgroundColor: 'red',
                },
                }}
            >
                 Open in google maps
            </Button>
        </Box>
        <Box sx={{ backgroundColor: '#000', p: 1, mb: 2, mt: 4 }}>
            <Typography variant="subtitle1" color="white">
              RESULTATS
            </Typography>
        </Box>
        <Box p={2}>
      <Typography variant="h6" gutterBottom>
        Détails de l'itinéraire :
      </Typography>
      <TableContainer>
        <Table size="small">
          <TableBody>
            <TableRow>
              <TableCell>Itinéraire</TableCell>
              <TableCell>DAOUDIAT - AZZOUZIA</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Date</TableCell>
              <TableCell>2025-02-03 07:21</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>temps limite</TableCell>
              <TableCell>57 minutes</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Temps total (sans temps supplémentaire)</TableCell>
              <TableCell>11 minutes</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Temps total (avec temps supplémentaire)</TableCell>
              <TableCell>21 minutes</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Statut de la limite de temps</TableCell>
              <TableCell sx={{ color: 'green' }}>✓ Dans la limite de temps</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Distance totale</TableCell>
              <TableCell>3.58 km</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Arrêts atteints</TableCell>
              <TableCell>2 sur 2</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Taux de complétion</TableCell>
              <TableCell>100.0%</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

      <Box mt={4}>
        <Typography variant="h6" gutterBottom>
          Analyse du temps :
        </Typography>
        <TableContainer>
          <Table size="small">
            <TableBody>
              <TableRow>
                <TableCell>Temps de base de l'itinéraire</TableCell>
                <TableCell>11 minutes</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Temps supplémentaire</TableCell>
                <TableCell>10 minutes</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Statut</TableCell>
                <TableCell sx={{ color: 'green' }}>
                  ✓ L'itinéraire est réalisable même avec le temps supplémentaire (46 minutes sous la limite)
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box><Box p={2}>
      <Typography variant="h6" gutterBottom>
        Détails de l'itinéraire :
      </Typography>
      <TableContainer>
        <Table size="small">
          <TableBody>
            <TableRow>
              <TableCell>Itinéraire</TableCell>
              <TableCell>DAOUDIAT - AZZOUZIA</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Date</TableCell>
              <TableCell>2025-02-03 07:21</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>temps limite</TableCell>
              <TableCell>57 minutes</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Temps total (sans temps supplémentaire)</TableCell>
              <TableCell>11 minutes</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Temps total (avec temps supplémentaire)</TableCell>
              <TableCell>21 minutes</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Statut de la limite de temps</TableCell>
              <TableCell sx={{ color: 'green' }}>✓ Dans la limite de temps</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Distance totale</TableCell>
              <TableCell>3.58 km</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Arrêts atteints</TableCell>
              <TableCell>2 sur 2</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Taux de complétion</TableCell>
              <TableCell>100.0%</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

      <Box mt={4}>
        <Typography variant="h6" gutterBottom>
          Analyse du temps :
        </Typography>
        <TableContainer>
          <Table size="small">
            <TableBody>
              <TableRow>
                <TableCell>Temps de base de l'itinéraire</TableCell>
                <TableCell>11 minutes</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Temps supplémentaire</TableCell>
                <TableCell>10 minutes</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Statut</TableCell>
                <TableCell sx={{ color: 'green' }}>
                  ✓ L'itinéraire est réalisable même avec le temps supplémentaire (46 minutes sous la limite)
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
        <Box>
            <iframe
            title="Google Map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3875.7562802733644!2d100.54655041550001!3d13.724893801085902!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30e29f3d8f9f2db5%3A0x6f2ef9a4895671c5!2sGoogle%20Thailand%20Office!5e0!3m2!1sen!2sth!4v1617154202027!5m2!1sen!2sth"
            width="100%"
            height="500"
            style={{ borderRadius: '4px' }}
           />
        </Box>

      </Box>
    </>
  );
}